import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import tvgConf from "@tvg/conf";

import OnfidoPageRegistrationTemplate from "@tvg/atomic-ui/_templates/OnfidoPageRegistration";
import {
  handleErrorModalRegistrationAction,
  setHasValidatedOnfidoRegistrationAction
} from "../actions";
import {
  getApplicantId,
  getOnfidoToggle,
  getRegistrationTexts,
  getSdkToken,
  getStoredResidentialStateAbbr,
  getUuid
} from "../utils/selectors";

export const Onfido = ({ device, isMEP }) => {
  const dispatch = useDispatch();

  const registrationTexts = useSelector(getRegistrationTexts);
  const homeState = useSelector(getStoredResidentialStateAbbr);
  const applicantId = useSelector(getApplicantId);
  const sdkToken = useSelector(getSdkToken);
  const uuid = useSelector(getUuid);
  const enableOnfido = useSelector(getOnfidoToggle);

  const [onfidoInstance, setOnfidoInstance] = useState(null);

  const initOnfido = async () => {
    try {
      const statesPassportReq = get(
        registrationTexts,
        "onfido.statesPassportReq",
        []
      );

      const showPassportOption = statesPassportReq.includes(homeState);

      const instance = window.Onfido.init({
        useModal: false,
        token: sdkToken,
        language: "en_US",
        containerId: isMEP ? "app" : "onfido-mount",
        onError: () => {
          dispatch(
            handleErrorModalRegistrationAction({
              isOpen: true,
              status: "failCreateAccount"
            })
          );
        },
        onComplete: () => {
          dispatch(setHasValidatedOnfidoRegistrationAction(true));
          dispatch(
            handleErrorModalRegistrationAction({
              isOpen: true,
              status: "onfidoChecks"
            })
          );
        },
        steps: [
          {
            type: "welcome",
            options: {
              title: "Verify your identity",
              descriptions: [
                "It should take a few minutes",
                "Use your device to photograph:",
                "1. your identity document",
                "2. your face"
              ],
              nextButton: "Choose document"
            }
          },
          {
            type: "document",
            options: {
              documentTypes: {
                driving_licence: true,
                national_identity_card: false,
                residence_permit: false,
                passport: showPassportOption
              }
            }
          },
          {
            type: "face",
            options: {
              requestedVariant: "standard",
              useMultipleSelfieCapture: false,
              uploadFallback: false
            }
          }
        ]
      });

      setOnfidoInstance(instance);
    } catch (err) {
      dispatch(
        handleErrorModalRegistrationAction({
          isOpen: true,
          status: "failCreateAccount"
        })
      );
    }
  };

  useEffect(() => {
    if (
      applicantId &&
      sdkToken &&
      uuid &&
      registrationTexts &&
      enableOnfido &&
      typeof window !== "undefined"
    ) {
      initOnfido();
    }
  }, []);

  useEffect(() => {
    return () => {
      if (onfidoInstance) {
        onfidoInstance.tearDown();
      }
    };
  }, [onfidoInstance]);

  return !isMEP || !device === "mobile" ? (
    <OnfidoPageRegistrationTemplate device={device} brand={tvgConf().brand}>
      <div id="onfido-mount" />
    </OnfidoPageRegistrationTemplate>
  ) : null;
};

export default Onfido;
